<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card class="box-card">
					<el-row>
						<el-col :span="24">
							<button class="selectAll" @click="goback" style="margin: 0 0 30px 0;">返回</button>
							<el-table   
                            :default-sort = "{prop: 'id',prop:'order', order: 'descending'}" 
                            v-loading="loading" element-loading-text="拼命加载中" 
                            element-loading-spinner="el-icon-loading"
							element-loading-background="rgba(0, 0, 0, 0.8)" 
                            size="mini" 
                            ref="multipleTable" 
                            :data="tableData" 
                            style="width: 100%"
							border 
                            :header-cell-style="{background:'#E5E7EE',color:'#000000'}" 
                            row-key="id"  
							 @select-all="selectAll"   >
								<!-- <el-table-column prop="id" label="编号" align="center "  sortable>
								</el-table-column> -->
								<el-table-column prop="orderNum" label="排序" align="center" sortable>
								</el-table-column>
                                <el-table-column prop="title" label="标题" align="center">
								</el-table-column>
                                <el-table-column prop="subTitle" label="副标题" align="center">
								</el-table-column>
								<el-table-column prop="bgImage" label="背景图" align="center">
									<template slot-scope="scope">
										<div class="demo-image__preview" @click="preview(scope.row)">
											<img style="width: 80px; height: 80px"
												:src="settings.apiBaseImg+scope.row.bgImage">
										</div>
									</template>
								</el-table-column>
                                <!-- <el-table-column prop="content" label="内容" align="center">
								</el-table-column> -->
								<el-table-column fixed="right" label="更多操作">
									<template slot-scope="scope">
										<el-button type="success" icon="el-icon-edit" circle  size="small"  @click.native.prevent="update('update',scope.row)"></el-button>
										<el-button type="danger" icon="el-icon-delete" circle  @click.native.prevent="deleteRow(scope.$index,scope.row)"  size="small"></el-button>
										<el-button type="primary"  icon="el-icon-top"  circle  size="small"    @click.native.prevent="order('0', scope.row)"></el-button>
                    					<el-button type="primary"  icon="el-icon-bottom"  circle  size="small"    @click.native.prevent="order('1', scope.row)"></el-button>
									</template>
								</el-table-column>
							</el-table>
							<div class="tableFooter">
                                <input
                                class="add"
                                @click="update('add')"
                                type="button"
                                value="添加数据项"
                                style="float: left"
                                />
                            </div>
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[5, 10, 15, 20]"
                                :page-size="pageSize"
                                layout="total, prev, pager, next, jumper"
                                :total="total"
                            >
                            </el-pagination>
						</el-col>
					</el-row>

				</el-card>
			</el-col>
		</el-row>
		<fox-preview-image v-model="visiable" :src="srcList" z-index="9000"></fox-preview-image>
       
	</div>
</template>

<script>
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
	export default {
		data() {
			return {
                id:'',
				tableData: [],
				currentPage: 1,
				pageSize: 5,
				total: 0,
				addType: '',
				loading: false,
				srcList: '',
				visiable: false,
			}
		},
		created() {
			// 专题id
            this.id = this.$route.query.id
            console.log(this.id)
            this.getSpecialItem(this.currentPage,this.pageSize)
		},
		methods: {
			//获取专题列表数据
			getSpecialItem(cPage,pageSize) {
				this.loading = true
				var obj = this;
				obj.$http({
					method: 'get',
					url: '/api/v1/special/item/page',
					params: {
						specialId:this.id,
						PageNum: cPage,
						pageSize: pageSize,
						 
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.loading = false
						this.tableData = res.data.data.data
                        console.log(res,'专题项列表')
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			// 查看图片
			preview(rows) {
				this.visiable = true
				this.srcList = ''
				this.srcList = this.settings.apiBaseImg + rows.formImage
			},
			//修改/添加
			update(iden, rows) {
				this.$router.push({
					path: '/home/specialItemAdd',
					query: {
						iden: iden,
                        rows:rows,
						id: this.id
					}
				})
			},
			// 返回首页
            goback(){
				this.$router.back()
                // this.$router.push({
				// 	path: '/home/special?id=',
				// })
            },
			
            // 删除专题项
			deleteRow(index, rows) {
				console.log(index)
				console.log(rows)
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					var obj = this;
					obj.$http({
						method: 'get',
						url: '/api/v1/special/item/delete/'+rows.id,
					}).then((res) => {
						if (res.status == 200) {
							obj.$message.success('删除成功')
							this.getSpecialItem()
						} else {
							obj.$message.error(res.data.message)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			//分页事件
			handleSizeChange(val) {
				this.pageSize = val; //将每页显示的条数 = 改变的值
				this.getSpecialItem(this.currentPage, this.pageSize)
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getSpecialItem(this.currentPage, this.pageSize)
			},
			// 全选/取消选操作
			selectAll(selection, first) {
				if (!first) {
					this.isAllSelect = !this.isAllSelect;
				}
				selection.map(el => {
					if (el.children) {
						el.children.map(j => {
							this.toggleSelection(j, this.isAllSelect);
						});
						if (el.children.length > 0) {
							this.selectAll(el.children, true);
						}
					}
				});
			},
			handleClose(done) {
				done();
			},

			// 排序
			order(type,rows) {
				console.log(type)
				console.log(rows)
				var obj = this;
				obj.$http({
				    method: 'get',
				    url:'/api/v1/special/item/change/order',
				    params: {
				        id:rows.id,
						type:type,
				    },
				    }).then((res) => {
				        if (res.status == 200) {
                            console.log(res,'修改排序')
							obj.$message.success('修改成功')
							this.getSpecialItem()
				           		
				        } else {
				           	obj.$message.error(res.message)
				        }
				})         
			},
            
	    },
    }
</script>

<style scoped="scoped">
	.selectAll{
		float: none;
	}
	/deep/ .el-input__inner {
		height: 40px !important;
	}

	/deep/ .el-form-item__label {
        width:250px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #000000;
		line-height: 24px;
	}

	/deep/ .el-button--text {
		font-family: PingFang SC;
		font-weight: 400;
		color: #7C96F8;
		line-height: 24px;
	}

	span ,/deep/ .el-table .cell{
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		line-height: 24px;
	}

	.chenggong {
		width: 49px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.7;
	}

	.fail {
		width: 33px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #76B67E;
		line-height: 24px;
	}

	/deep/ .el-message {
		z-index: 9999999999999;
	}
	/deep/ .el-table__row--level-0,/deep/ .expanded{
		/* background-color: #fdf5e6; */
	}
	/deep/ .el-table__row--level-1{
		background-color:#f0f9eb;
	}
/deep/ .el-table__row--level-2{
		background-color:#fdf5e6;
	}
	.addColumn{
	background-color: #7C96F8;
	color: #FFFFFF;
	border: 1px solid #7C96F8;
	}

	.el-button+.el-button {
    	margin-left: 0px;
	}
</style>



// WEBPACK FOOTER //
// src/views/system/special/specialItem.vue